import noDocuments from 'components/Quizzes/images/no-documents.svg';
import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Text } from 'shell/components';

const NoQuizzes = () => {
    const { device } = useViewport();
    const { t } = useTranslation('quiz');
    const isMobile = device === 'mobile';

    return (
        <Stack alignItems={'center'} spacing={3} sx={{ pt: isMobile ? 12 : '20vh', mx: 'auto', maxWidth: 600 }}>
            <Box
                component={'img'}
                src={noDocuments}
                alt={''}
                sx={{ width: isMobile ? 178 : 250, height: isMobile ? 75 : 105 }}
            />
            <Text align={'center'} color={'light'} component={'h2'} variant={'h6'} weight={'semibold'}>
                {t('empty.title', 'Import a Quiz')}
            </Text>
            <Text align={'center'} color={'light'} variant={'p2'} weight={'medium'}>
                {t(
                    'empty.description',
                    'Import a quiz from your LMS to start grading short and long answer questions.'
                )}
            </Text>
        </Stack>
    );
};

export default NoQuizzes;
